import * as React from "react";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";

import styles from "./css/home.module.scss";

export const HomeComponent: React.SFC = () => (
    <div className={styles.container}>
        <img
            src={"/home_top.svg"}
            alt="first_view"
            className={styles.firstView}
        />
        <div className={styles.spContainer}>
            <img src={"/logo-200x200.png"} alt="logo" />
            <h2>様々なSNSを一つのタイムラインで見れる</h2>
            <h2>SNS管理の完全版</h2>
        </div>
        <img src={"/sp-demo.svg"} alt="sp-demo" className={styles.spImage} />
        <div className={styles.buttonWrapper}>
            <Link style={{textDecoration: "none"}} to="/demo">
                <Button
                    className={styles.goToDemo}
                    variant="contained"
                    size="large"
                >
                    デモを見る
                </Button>
            </Link>
            <Link style={{textDecoration: "none"}} to="/login">
                <Button
                    className={styles.loginButton}
                    variant="contained"
                    size="large"
                >
                    ログイン
                </Button>
            </Link>
        </div>
    </div>
);
